<div class="layout-topbar" style="background-color: white;">
    <a class="layout-topbar-logo" routerLink="" style="padding-left: 40px;">
        <!-- <img src="assets/layout/images/PotentPNG.png" alt="logo" style="border-radius: 5px;background-color:rgb(2, 2, 23);"> -->
        <img src="assets/layout/images/PotentPNG.png" alt="logo"
    style="width: 150px; height: auto; padding: 10px; border-radius: 5px; box-shadow: 0 0 10px rgba(0, 0, 0, 0.2); background-color: rgb(2, 2, 23);  margin-bottom: 10px;">

    </a>

    <button #menubutton class="p-link layout-menu-button layout-topbar-button" (click)="layoutService.onMenuToggle()">
        <i class="fas fa-bars" style="color: #1d2f6d;"></i>
    </button>

    <button #topbarmenubutton class="p-link layout-topbar-menu-button layout-topbar-button" (click)="layoutService.showProfileSidebar()">
        <i class="pi pi-ellipsis-v"></i>
    </button>
    <div class="mt-2 role">
      <h3>{{role}}</h3>
    </div>
    <div class="search-bar">
      <input
        type="text"
        [(ngModel)]="searchQuery"
        placeholder="Search..."
      />
      <!-- <button id="myBtn" >Search</button> -->
      <button class="search-button" (click)="openModal()" [disabled]="!searchQuery" style="border: solid 1px #1d2f6d; color: white; background-color: #1d2f6d; border-radius: 5px; height: 40px; width: 40px;">
        <!-- <i class="pi pi-search"></i> -->
        <i class="fa-solid fa-magnifying-glass"></i>
      </button>
    </div>

    <div class="user-menu" #topbarmenu>
        <button class="p-link user-icon" (click)="toggleUserMenu()" style="border: solid 1px #1d2f6d;">
            <!-- <i class="pi pi-fw pi-user" ></i> -->
            <i class="fa-solid fa-user" style="color: #1d2f6d;"></i>
            <span>{{ vendorCode}}</span>
        </button>
        <ul *ngIf="userMenuVisible" class="user-dropdown">
            <li (click)="navigateToProfile()">
                <i class="pi pi-fw pi-user-edit"></i>
                Profile
            </li>
            <li (click)="logout()">
                <i class="pi pi-fw pi-sign-out"></i>
                Logout
            </li>
        </ul>
    </div>


    <!-- <div #topbarmenu class="layout-topbar-menu" *ngIf="loggedInUser" [ngClass]="{'layout-topbar-menu-mobile-active': layoutService.state.profileSidebarVisible}">
        <p-menubar [model]="items"></p-menubar>
    </div> -->
</div>
<div id="myModal" class="modal" [ngClass]="{ show: visible }" (click)="onWindowClick($event)">
  <div class="modal-content">
      <span class="close" (click)="closeModal()">&times;</span>
      <h2>Search Results:</h2>
      <div *ngIf="searchResponse.length; else noResults">
          <table>
              <thead>
                  <tr>
                      <th>Field Name</th>
                      <th>Value</th>
                  </tr>
              </thead>
              <tbody>
                  <tr *ngFor="let item of searchResponse" (click)="handleItemClick(item)">
                      <td>{{ item.doctype }}</td>
                      <td>{{ item.name }}</td>
                  </tr>
              </tbody>
          </table>
      </div>
      <ng-template #noResults>
          <p>No results found.</p>
      </ng-template>
  </div>
</div>

<style>
.user-menu {
    position: relative;
    display: flex;
    align-items: center;
    background-color: white;
    border-radius: 5px;
    /* padding: 5px 10px; */
    }

.user-icon {
    background: none;
    border: none;
    color: #1d2f6d;
    cursor: pointer;
    display: flex;
    align-items: center;
    padding: 10px;
}

.user-icon i {
    font-size: 15px;
    margin-right: 5px;
}
.user-icon .pi-user {
    color: #1d2f6d;
}
.user-menu span {
    margin-left: 10px;
    margin-right: 10px;
}

.user-dropdown {
    position: absolute;
    top: 100%;
    right: 0;
    background-color: white;
    border: 1px solid #ccc;
    border-radius: 4px;
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
    list-style: none;
    margin: 0;
    padding: 0;
    width: 150px;
    z-index: 1000;
}

.user-dropdown li {
    padding: 10px;
    cursor: pointer;
    color: #333;
}

.user-dropdown li:hover {
    background-color: #f5f5f5;
}


  .layout-topbar {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 10px 50px;
    flex-wrap: wrap;
}

.layout-topbar-logo img {
    max-height: 60px;
}

.layout-menu-button,
.layout-topbar-menu-button {
    background: none;
    border: none;
    cursor: pointer;
    padding: 10px;
}

.layout-menu-button i,
.layout-topbar-menu-button i {
    font-size: 24px;
    color: white;
}

.search-bar {
    display: flex;
    align-items: center;
    flex-grow: 1;
    justify-content: flex-end;
}
/* style="min-width:55%;display:flex; justify-content:center;" */
.role{
  min-width:10%;
  display:flex;
  justify-content: center;
  margin-left:20%;
}
@media (max-width: 768px) {
  .role {
    margin-left: 0; /* Adjust margin for smaller screens */
    justify-content: flex-start; /* Align content to the left */
  }
}

.search-bar input {
    padding: 10px;
    border: 1px solid #ccc;
    border-radius: 4px;
    /* width: 150px; */
    margin-right: 2px;
}

.search-bar button {
    padding: 5px 10px;
    background-color: #2c436b;
    color: white;
    border: none;
    border-radius: 3px;
    cursor: pointer;
    margin-right: 15px;
}


@media (max-width: 767px) {
    .layout-topbar {
        flex-direction: column;
        align-items: stretch;
    }

    .search-bar {
        /* width: 50%; */
        margin-top: 10px;
        margin-right: 2px;
        justify-content: center;
    }
    .search-bar input {
        width: 150px;
    }

    .layout-menu-button,
    .layout-topbar-menu-button {
        order: -1;
    }
}



.modal {
    display: none;
    position: fixed;
    z-index: 1;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    overflow: auto;
    background-color: rgba(0, 0, 0, 0.4);
}

.modal-content {
    background-color: #fff;
    margin: 5% auto;
    padding: 20px;
    border: 1px solid #888;
    border-radius: 10px;
    box-shadow: 0 5px 15px rgba(0, 0, 0, 0.3);
    width: 50%;
    max-width: 600px;
    position: relative;
    animation: fadeIn 0.3s;
}

@keyframes fadeIn {
    from { opacity: 0; transform: translateY(-10px); }
    to { opacity: 1; transform: translateY(0); }
}

.close {
    color: #aaa;
    float: right;
    font-size: 28px;
    font-weight: bold;
    cursor: pointer;
}

.close:hover,
.close:focus {
    color: #1d2f6d;
    text-decoration: none;
}

.modal.show {
    display: block;
}

h2 {
    margin-top: 0;
    font-size: 24px;
    color: #333;
    text-align: center;
}

table {
    width: 100%;
    border-collapse: collapse;
    margin: 20px 0;
}

th, td {
    padding: 12px;
    text-align: left;
    border-bottom: 1px solid #ddd;
}

th {
    background-color: #f2f2f2;
}

tr:hover {
    background-color: #f5f5f5;
    cursor: pointer;
}

.view-button {
    background-color: #2c436b;
    color: white;
    border: none;
    padding: 10px 20px;
    border-radius: 4px;
    cursor: pointer;
}

.view-button:hover {
    background-color: #1a2a48;
}
</style>
